<template>
    <el-dialog :close-on-click-modal="false" title="运维工程师" width="29%" v-bind="$attrs" v-on="$listeners" class="h-dialog3 ljjtitlesblue">
        <div class="h-checkType">
            <div class="ljj_yunwenbox" v-for="(item,index) in yunweilist" :key="index">
				<div class="ljj_title1">{{item.titles}}</div>
				<div class="ljj_title2">{{item.texts}}</div>
			</div>
        </div>
        <div slot="footer" class="dialog-footer">
			<el-button class="h-btn h-formBtn h-bgblue2" @click="queren">确认</el-button>
        </div>
    </el-dialog>
</template>
<script>
	import ss from "../../api/SystemService";
export default {
    data(){
        return {
            //弹框
            dialogFormVisible:false,
			yunweilist:[
				{
					titles:'姓名/工号：',
					texts:'赵岩蕊'
				},
				{
					titles:'手机号：',
					texts:'15953806735'
				},
				{
					titles:'邮箱：',
					texts:'yuanhangyl@yuanh.com.cn'
				}
			]
        }
    },
	mounted() {

	},
    methods:{
        hetongbtn(index){
            this.hetongdex = index;
        },
        queren(){
			this.dialogFormVisible=false
            this.$emit('imgfalse1');
        },
		
    },
	created() {
		
	},
    props: {
        dialogVisible: {
            type: Boolean,
        },
    }
}
</script>
<style scoped>
	.ljj_yunwenbox{
		margin-bottom: 0.15rem;
	}
	.ljj_title1{
		color: #3a4b60;
		font-size: 0.16rem;
		font-weight: 600;
	}
	.ljj_title2{
		margin-top: 0.05rem;
		font-size: 0.14rem;
		color: #3a4b60;
	}
</style>